// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/containers/resultsPage/_results.scss
 ** module id = 1909
 ** module chunks = 0
 **/